import React from "react";
import { logError } from "shared/services/ErrorReporting";

interface IErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface IErrorBoundaryProps {
  children: React.ReactNode;
  fallback: React.ComponentType<{ error: Error }>;
}

export class ErrorBoundary extends React.Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): IErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logError(error, { react: { componentStack: errorInfo.componentStack } });
  }

  render() {
    const { hasError, error } = this.state;
    const { fallback: FallbackComponent, children } = this.props;

    if (hasError && error) {
      return <FallbackComponent error={error} />;
    }

    return children;
  }
}
